import React from 'react';
import { Notice } from '../types/notice';

interface NoticeMarqueeProps {
  notice: Notice;
  onClick?: () => void;
}

const NoticeMarquee: React.FC<NoticeMarqueeProps> = ({ notice, onClick }) => {
  return (
    <div 
      className="notice-marquee-container"
      onClick={onClick}
      style={{ 
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '';
        }
      }}
    >
      <div className="notice-marquee">
        <div className="notice-marquee-icon">
          <i className="bi bi-megaphone-fill"></i>
        </div>
        <div className="notice-marquee-content">
          <div className="notice-marquee-text" key={notice.id}>
            <span className="notice-marquee-title">{notice.title}</span>
            {notice.description && (
              <>
                <span className="notice-marquee-separator"> • </span>
                <span className="notice-marquee-description">{notice.description}</span>
              </>
            )}
          </div>
          {/* Duplicate for seamless loop */}
          <div className="notice-marquee-text" aria-hidden="true">
            <span className="notice-marquee-title">{notice.title}</span>
            {notice.description && (
              <>
                <span className="notice-marquee-separator"> • </span>
                <span className="notice-marquee-description">{notice.description}</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeMarquee;
